(() => {
  const DESKTOP_CLASSES = [1, 2, 3, 4, 5, 6].map((columns) => `grid--${columns}-col-desktop`);
  const MOBILE_CLASSES = [1, 2].map((columns) => `grid--${columns}-col-tablet-down`);
  const STORAGE_PREFIX = 'collection-layout-switcher';

  const getStorageKey = (wrapper, breakpoint) =>
    `${STORAGE_PREFIX}:${wrapper.dataset.sectionId || 'collection'}:${breakpoint}`;

  const getStoredColumns = (wrapper, breakpoint) => {
    try {
      return window.localStorage.getItem(getStorageKey(wrapper, breakpoint));
    } catch (error) {
      return null;
    }
  };

  const setStoredColumns = (wrapper, breakpoint, columns) => {
    try {
      window.localStorage.setItem(getStorageKey(wrapper, breakpoint), columns);
    } catch (error) {
      return;
    }
  };

  const getColumns = (wrapper, breakpoint) => {
    const storedColumns = getStoredColumns(wrapper, breakpoint);
    if (storedColumns) return storedColumns;

    return breakpoint === 'desktop' ? wrapper.dataset.defaultDesktop : wrapper.dataset.defaultMobile;
  };

  const updateButtons = (wrapper, breakpoint, columns) => {
    wrapper.querySelectorAll(`[data-breakpoint="${breakpoint}"]`).forEach((button) => {
      const isActive = button.dataset.columns === columns;
      button.classList.toggle('is--active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  };

  const getGrid = (wrapper) => {
    const collection = wrapper.closest('.collection');
    if (collection) return collection.querySelector('#product-grid');

    const collectionComponent = wrapper.closest('collection-component') || document;
    return collectionComponent.querySelector('#ProductGridContainer #product-grid');
  };

  const applyLayout = (wrapper) => {
    const grid = getGrid(wrapper);
    if (!grid) return;

    const desktopColumns = getColumns(wrapper, 'desktop');
    const mobileColumns = getColumns(wrapper, 'mobile');

    grid.classList.remove(...DESKTOP_CLASSES, ...MOBILE_CLASSES);
    grid.classList.add(`grid--${desktopColumns}-col-desktop`, `grid--${mobileColumns}-col-tablet-down`);

    updateButtons(wrapper, 'desktop', desktopColumns);
    updateButtons(wrapper, 'mobile', mobileColumns);
  };

  const initLayoutSwitchers = () => {
    document.querySelectorAll('[data-layout-switcher]').forEach(applyLayout);
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-layout-switcher] button[data-breakpoint][data-columns]');
    if (!button) return;

    const wrapper = button.closest('[data-layout-switcher]');
    setStoredColumns(wrapper, button.dataset.breakpoint, button.dataset.columns);
    applyLayout(wrapper);
  });

  document.addEventListener('DOMContentLoaded', () => {
    initLayoutSwitchers();

    const gridContainer = document.getElementById('ProductGridContainer');
    if (!gridContainer) return;

    const observer = new MutationObserver(() => {
      window.requestAnimationFrame(initLayoutSwitchers);
    });

    observer.observe(gridContainer, { childList: true, subtree: true });
  });
})();
